var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bb-overlay',{attrs:{"visible":"","centerVertically":"","constrained":false,"color":"dark"},on:{"close":function($event){_vm.show = false}}},[_c('bb-spinner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }